export default function (opts) {
    const el = document.querySelector(opts.el);
    // 记录
    let firstAction = true;
    let halfContent = true;
    let statement = true;

    // 鼠标进入事件
    el.addEventListener('mouseenter', function () {
        if (firstAction) {
            window?.sohuSpm?.sendAction({ acode: 8093 });
            firstAction = false;
        }
    });

    function sendCode() {
        const contentTop = el?.getBoundingClientRect()?.top + window.scrollY;
        const contentHeight = el?.offsetHeight;
        const statementEl = document.querySelector('.statement');
        const statementHeight = statementEl?.getBoundingClientRect()?.top + window.scrollY;
        // 中间内容跟踪
        const isHalfContent = halfContent &&
            (contentTop + contentHeight * 0.5) >= window.scrollY &&
            (contentTop + contentHeight * 0.5) <= window.scrollY + window.innerHeight
        // 声明内容跟踪
        const isStatement = statement &&
            statementHeight >= window.scrollY &&
            statementHeight <= window.scrollY + window.innerHeight
        
        if (isHalfContent) {
            window?.sohuSpm?.sendAction({ acode: 8094 });
            halfContent = false;
        }

        if (isStatement) {
            window?.sohuSpm?.sendAction({ acode: 8095 });
            statement = false;
        }
    }

    // 滚动事件绑定
    window.addEventListener('scroll', sendCode);
}
